<dx-header-curve></dx-header-curve>
<dx-page-navbar></dx-page-navbar>
<div class="page-container container-fluid">
  <ng-container *ngIf="(account$ | async) as account; else loadingOrError">
    <dx-page-header title="Insured"></dx-page-header>
    <div class="row mb-3">
      <div class="col">
        <div class="text-secondary">Insured</div>
        <div>
          <fa-icon [icon]="faUserShield" [fixedWidth]="true" class="h4 text-info me-2"></fa-icon>
          <span class="h3 fw-black">{{ account.insuredName }}</span>
          <span class="h5 text-info fw-normal ps-2">#{{ account.accountNumber }}</span>
        </div>
      </div>
      <div class="col-auto">
        <a *ngIf="authService.isAgent" class="btn btn-light card" routerLink="/account">
          <div class="card-body">
            <div class="row align-items-center justify-content-between">
              <div class="col-auto d-flex align-items-center text-start">
                <fa-layers class="me-1" [fixedWidth]="true" size="3x">
                  <fa-icon class="icon-gray" [icon]="['fas', 'circle']"></fa-icon>
                  <fa-icon class="text-primary" [icon]="faUsers" transform="shrink-8"></fa-icon>
                </fa-layers>
                <div class="h6 mb-0">
                  All Insureds
                </div>
              </div>
              <div class="col-auto">
                <fa-icon class="text-primary" [fixedWidth]="true" [icon]="['fas', 'chevron-right']"></fa-icon>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <div class="text-secondary">Primary Address</div>
        <div>
          <fa-icon [icon]="faMapMarkerAlt" [fixedWidth]="true" class="h4 text-info me-2"></fa-icon>
          <span class="h5 fw-normal">{{ displayAddress(account) }}</span>
        </div>
      </div>
      <div class="col-auto align-self-center"></div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card">
          <nav>
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a class="nav-link" routerLink="summary" routerLinkActive="active">Summary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="policies" routerLinkActive="active">Policies</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="billing" routerLinkActive="active">Billing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="claims" routerLinkActive="active">Claims</a>
              </li>
            </ul>
          </nav>
          <div class="card-body">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #loadingOrError>
    <ng-container *ngIf="(hasError$ | async); else loading">
      <ng-container *ngIf="error.status === 404; else pageError">
        <dx-not-found></dx-not-found>
      </ng-container>
      <ng-template #pageError>
        <dx-page-error [status]="error.status"></dx-page-error>
      </ng-template>
    </ng-container>
    <ng-template #loading>
      <dx-page-loading title="Insured" cardHeight="800px"></dx-page-loading>
    </ng-template>
  </ng-template>
</div>
